import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import NodeZeroConfigListing from './NodeZeroConfigListing'
import NodeZeroCredentialsForm from './NodeZeroCredentialsForm'

export default function NodeZeroPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={NodeZeroCredentialsForm}
            PullConfigListingView={NodeZeroConfigListing}
        />
    )
}